import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      d: "M4.745 3.007a23.9 23.9 0 0 0-1.745 9c0 3.183.62 6.22 1.745 9m14.755-18c.967 2.78 1.5 5.817 1.5 9s-.533 6.22-1.5 9M8.25 8.89l1.444-.888a.75.75 0 0 1 1.105.401l2.402 7.206a.75.75 0 0 0 1.104.401l1.445-.889m-8.25.75.213.09a1.69 1.69 0 0 0 2.062-.618l4.45-6.675a1.69 1.69 0 0 1 2.062-.618l.213.09"
    }, null, -1)
  ])))
}
export default { render: render }